// Dev-only logger — silent in production builds, identical surface to console.
// Use this instead of console.* so production bundles stay quiet (and we don't
// leak operator hints to the network panel of a curious visitor).
const isDev = typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production";

export const log = {
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};
